// Version: Increment by 0.01 for each change
export const APP_VERSION = '0.15';

// Build number: Auto-generated at build time (YYYYMMDD.HHMM)
function generateBuildNumber() {
  const now = new Date();
  const y = now.getFullYear();
  const mo = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  const h = String(now.getHours()).padStart(2, '0');
  const mi = String(now.getMinutes()).padStart(2, '0');
  return `${y}${mo}${d}.${h}${mi}`;
}

export const BUILD_NUMBER = generateBuildNumber();
